import {UseFormReturnType} from "@mantine/form";
import {useTranslation} from "react-i18next";
import {Button, Divider, Grid, Modal, ModalProps, TextInput} from "@mantine/core";
import {useCallback} from "react";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import {useGeofenceSiteGroupForm} from "./useGeofenceSiteGroupForm";

export interface GeofenceSiteGroupFormProps {
  options?: GeofenceSiteGroupFormOptions;
  defaultValues?: GeofenceSiteGroupFormDefaultValues;
  onSubmit?: (values: GeofenceSiteGroupFormValues) => void;
  submitting?: boolean;
}

export interface GeofenceSiteGroupFormOptions {

}

export interface GeofenceSiteGroupFormValues {
  name: string;
}

export interface GeofenceSiteGroupFormDefaultValues extends Partial<GeofenceSiteGroupFormValues> {

}

export interface GeofenceSiteGroupFormRawValues {
  name?: string;
}

export type GeofenceSiteGroupFormType = UseFormReturnType<GeofenceSiteGroupFormRawValues, (values: GeofenceSiteGroupFormRawValues) => GeofenceSiteGroupFormRawValues>

export const GeofenceSiteGroupForm = (props: GeofenceSiteGroupFormProps) => {
  const {
    options,
    defaultValues,
    onSubmit,
    submitting = false
  } = props;

  const region = useApp();

  const {t} = useTranslation(["common"]);

  const form = useGeofenceSiteGroupForm({
    defaultValues: defaultValues,
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {

    if (onSubmit) {
      onSubmit({
        name: values.name!,
      });
    }
  }, [form, onSubmit]);

  return (
    <form onSubmit={form.onSubmit(onFormSubmit)}>
      <Grid grow gutter="xs">
        <Grid.Col span={12}>
          <TextInput
            label={t("common.entity.geofencesitegroup.form.field.name", "Name")}
            placeholder={t<string>("common.entity.geofencesitegroup.form.field.name.placeholder", "Name")}
            withAsterisk
            required
            {...form.getInputProps("name")} />
        </Grid.Col>
      </Grid>
      <Divider my="sm" variant="dotted"/>
      <Button type="submit" loading={submitting} fullWidth mt="xl">
        {t("common.action.submit", {ns: "common"})}
      </Button>
    </form>
  );
};

interface GeofenceSiteGroupFormModalProps extends GeofenceSiteGroupFormProps, Omit<ModalProps, 'onSubmit'> {

}

export const GeofenceSiteGroupFormModal = (props: GeofenceSiteGroupFormModalProps) => {
  const {
    defaultValues,
    onSubmit,
    submitting,
    ...rest
  } = props;

  return (
    <Modal {...rest}>
      <GeofenceSiteGroupForm defaultValues={defaultValues} onSubmit={onSubmit} submitting={submitting}/>
    </Modal>
  );
};
